import request from './request';

const referee_info = {
	async getRefereeInfo(id) {
		const response = await request.get(`/app/referee-infos/id?id=${id}`);
		return response;
	},
	async createRefereeInfo(body) {
		const res = await request.post('/app/referee-infos', body);
		return res;
	},
	async updateRefereeInfo(body) {
		const res = await request.patch('/app/referee-infos/update', body);
		return res;
	}
};

export default referee_info;